import { AuthService } from 'src/app/core/services/auth.service';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { Component, HostListener } from '@angular/core';
import { Subscription, Observable, fromEvent } from 'rxjs';
import { ChatService } from './core/services/chat.service';
import { LOCAL_STORAGE_CONSTANT } from './core/services/local-storage.constant';
import { LocalStorageService } from './core/services/local-storage.service';
import { WebsocketService } from './core/services/websocket.service';
import { ContentsService } from './core/services/contents.service';
// import { BlobServiceClient, AnonymousCredential, newPipeline } from '@azure/storage-blob';
import { environment } from 'src/environments/environment';
import { PublicationNotUploadedComponent } from './components/all-modals/publication-not-uploaded/publication-not-uploaded.component';
import { VideoNotUploadedComponent } from './components/all-modals/video-not-uploaded/video-not-uploaded.component';
import { AudioNotUploadedComponent } from './components/all-modals/audio-not-uploaded/audio-not-uploaded.component';
import { HttpEventType, HttpEvent } from '@angular/common/http';
import { PublicationUploadedComponent } from './components/all-modals/publication-uploaded/publication-uploaded.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadSpaceModalComponent } from './components/wipod/upload-publication/upload-space-modal/upload-space-modal.component';
import { ErrorMessageComponent } from './components/all-modals/error-message/error-message.component';
import { LITERALS } from './core/constants/literals.constant';
import { ConnectionService } from 'ng-connection-service';
import { InernetConnectionComponent } from './components/all-modals/internet-connection/internet-connection.component';
import { TabActivityService } from './core/services/tab-activity.service';
// import { AWS } from "aws-sdk/lib/services/s3";

declare var AzureStorage: any;
declare var AWS: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'scriptdoor';

  isConnected = true;
  noInternetConnection: boolean;

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;

  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;
  userObj = {
    id: '',
    name: '',
    username: '',
    email: '',
    author: {},

  };
  userData = {};
  uploadDataSubscription: Subscription;
  seqFileSubscription: Subscription;
  cancelFileSubscription: Subscription;
  formData: FormData;
  uploadingData: any = [];
  submitted: boolean;
  str: string;
  isUploading: boolean = false;
  pendingCounter: number = 0;
  index: any = 0;
  speedSummary;
  cancelUploadFilter: any;
  internetModalRef;
  uploadCancelled: boolean = false;
  uploadStarted: boolean = false;
  disableCancel: boolean = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private _localStorageService: LocalStorageService,
    private chatService: ChatService,
    private webSocketService: WebsocketService,
    private _authService: AuthService,
    private _contentsService: ContentsService,
    private connectionService: ConnectionService,
    private modalService: NgbModal,
    private tabActivityService: TabActivityService
  ) {
    this.checkInternetConnectivity();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params["uuid_code"]){
        const currentOP = this.getMobileOperatingSystem();
        if(currentOP === 'iOS'){
          window.location.href = 'https://apps.apple.com/in/app/scriptdoor/id1514571177';
        } else if(currentOP === 'Android') {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.scriptdoor';
        }
      }
    });
    this.router.events.subscribe((evt) => {
      if(evt instanceof NavigationStart){
        if(evt.url.includes('uuid_code')){
          const currentOP = this.getMobileOperatingSystem();
          if(currentOP === 'iOS'){
            window.location.href = 'https://apps.apple.com/in/app/scriptdoor/id1514571177';
          } else if(currentOP === 'Android') {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.scriptdoor';
          }
        }
      }
      if (evt instanceof NavigationEnd) {

        this.checkInternetConnectivity();
      }

    });
  }

  checkInternetConnectivity() {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        if (this.internetModalRef) {
          this.internetModalRef.close();
        }
        this.noInternetConnection = false;
      } else {
        this.showInternetErrorModal();
        this.noInternetConnection = true;
      }
    });
  }

  showInternetErrorModal() {
    this.modalService.dismissAll();
    this.internetModalRef = this.modalService.open(InernetConnectionComponent, {backdrop: 'static', centered: true});
    this.internetModalRef.componentInstance.title = 'No Internet Connection';
    this.internetModalRef.componentInstance.message = 'Please check your network connection and try again.';
    this.internetModalRef.result.then(() => {
      if (this.noInternetConnection) {
        window.location.reload();
      }
    });
  }

  getMobileOperatingSystem(){
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        return "iOS";
    }

    return "unknown";
  }

  ngOnInit(): void {

    this.loadScripts();
    let userData;
    if (this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS)) {
      userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user;
    }
    if (userData && userData.user_account_type == 'supplementary') {
      this.str = "There is not enough available storage to upload content. Please contact your parent.";

    }

    this.tabActivityService.tabClosed$.subscribe(() => {
      if (this.userData) {
        this.webSocketService.offlineSocket(this.userData['chat_sku']);
      }
      console.log('Tab or browser window is being closed.');
      // Do something when the tab or browser window is being closed.
    });

    this.seqFileSubscription = this._authService.getSequenceFile().subscribe(
      (res) => {
        if (res) {
          if (this.uploadingData.length > this.index) {
            this.getPreAssignedURL(res.type, res.name, this.index);
          }
        }
      });
    this.cancelFileSubscription = this._authService.cancelUploadingFile().subscribe(
      (res) => {
        if (res) {
          this.isUploading = false;
          this.cancelUploadFilter.cancel = true;

          let uploadPanel = document.getElementsByClassName("upload-panel");
          uploadPanel[0].classList.add('hide');
          uploadPanel[0].classList.remove('show');

          this.uploadingData = [];
          this.index = 0;

          this.pendingCounter = 0;
        }
      });

    this.uploadDataSubscription = this._authService.getUploadingQueue().subscribe(
      (item) => {
        if (item) {
          this.showUploadPanel();
          this.uploadData(item);
        }
      });

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        this.cancelUploadFilter.cancel = false;
        return;
      }
      window.scrollTo(0, 0)
    });

    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet';
      this.connectionStatus = 'offline';
    }));
    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
      this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
    if (this.userData) {
      this.userObj.id = this.userData['chat_sku'];
      this.userObj.name = this.userData['name'];
      this.userObj.username = this.userData['chat_sku'];
      this.userObj.email = this.userData['email'];
      this.userObj.author = {
        id: this.userData['chat_sku'],
        name: this.userData['name'],
        username: this.userData['chat_sku'],
        email: this.userData['email']
      };
      this.chatService.connectToSocket(this.userObj);
    }
    this.cancelUploadFilter = {
      cancel: false,              // Set to true to cancel an in-progress upload

      loggingOn: true,            // Set to true to see info on console

      onCancelComplete: null,     // Set to a function you want called when a cancelled request is (probably?) complete,
      // i.e. when returnCounter==nextCounter. Because when you cancel an upload it can be many
      // seconds before the in-progress chunks complete.

      // Internal from here down

      nextCounter: 0,             // Increments each time next() is called. a.k.a. 'SentChunks' ?
      returnCounter: 0,           // Increments each time next()'s callback function is called. a.k.a. 'ReceivedChunks'?
      handle: function (requestOptions, next) {
        var self = this;
        if (self.cancel) {
          self.log('cancelling before chunk sent');
          return;
        }
        if (next) {
          self.nextCounter++;
          next(requestOptions, function (returnObject, finalCallback, nextPostCallback) {
            self.returnCounter++;
            if (self.cancel) {
              self.log('cancelling after chunk received');
              if (self.nextCounter == self.returnCounter && self.onCancelComplete) {
                self.onCancelComplete();
              }

              // REALLY ??? Is this the right way to stop the upload?
              return;

            }
            if (nextPostCallback) {
              nextPostCallback(returnObject);
            } else if (finalCallback) {
              finalCallback(returnObject);
            }
          });
        }
      },
      log: function (msg) {
        if (this.loggingOn) {
          // console.log('cancelUploadFilter: ' + msg + ' nc: ' + this.nextCounter + ', rc: ' + this.returnCounter);
        }
      },
    };
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
      this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
    if (this.userData) {
      this.webSocketService.offlineSocket(this.userData['chat_sku']);
    }
    if (this.isUploading) {
      var message = 'Custom message not working';
      if (typeof event == 'undefined') {
        event = window.event;
      }
      if (event) {
        event.returnValue = message;
      }
      return message;
    }
  }

  //Load the captcha scripts
  loadScripts() {
    const scriptPath = environment.scriptPath;
    this.loadScriptFromPath(scriptPath);
  }

  loadScriptFromPath(scriptPath: string) {
    const script = document.createElement('script');
    script.src = scriptPath;
    document.body.appendChild(script);
  }

  uploadData(uploadData) {

    if (this.uploadingData.length > 0 && this.pendingCounter <= 0) {
      this.uploadingData.map((item) => {
        item['isNew'] = false
      });
    }
    uploadData.forEach((element, index) => {

      element['status'] = 'pending';
      // element['progress'] = 0;
      // Had to use below line for AWS
      // we have to use httpUploadProgress instead of progress
      element['httpUploadProgress'] = 0;
      element['uploadedBytes'] = 0;
      element['isNew'] = true;

      if (element.formData.library_type == 'wipod')
        element['isSubmitted'] = true;
      else
        element['isSubmitted'] = false;

      this.uploadingData.push(element);

      this.pendingCounter++;
    });

    if (!this.isUploading) {
      if (this.uploadingData[this.index].audioBook) {
        this.getPreAssignedURL('audioBook', this.uploadingData[this.index].audioBook.name, this.index);
      }
      else if (this.uploadingData[this.index].trailer) {
        this.getPreAssignedURL('trailer', this.uploadingData[this.index].trailer.name, this.index);
      }
      else if (this.uploadingData[this.index].content) {
        this.getPreAssignedURL('content', this.uploadingData[this.index].content.name, this.index);
      }
      else {
        this.isUploading = true;
        this.onSubmit();
      }
    }
  }

  getPreAssignedURL(uploadType, name, index) {
    this.uploadCancelled = false;
    this.isUploading = true;
    localStorage.setItem('uploadingProcess', 'true');
    this.formData = new FormData();
    if (uploadType == 'content') {
      this.formData.append('file_name', name);
    }
    else if (uploadType == 'audioBook') {
      this.formData.append('file_name', name);
    }
    else if (uploadType == 'trailer') {
      this.formData.append('file_name', name);
    }

    this._contentsService.getPresignedUrl(this.formData).subscribe(
      (res) => {
        // console.log('this');
        if (!this.uploadCancelled) {
          if (uploadType == 'content') {
            this.uploadingData[index].formData['link'] = res.data.link;
            // console.log(res.data.link);
            this.uploadFilesToAWS(this.uploadingData[index].content, res.data, uploadType, index);
          }
          else if (uploadType == 'audioBook') {
            this.uploadingData[index].formData['audio_book'] = res.data.link;
            // console.log(res.data.link);
            this.uploadFilesToAWS(this.uploadingData[index].audioBook, res.data, uploadType, index);
          }
          else if (uploadType == 'trailer') {
            this.uploadingData[index].formData['preview_link'] = res.data.link;
            // console.log(res.data.link);
            this.uploadFilesToAWS(this.uploadingData[index].trailer, res.data, uploadType, index);
          }
        }
      }, (error: any) => {
        this.index++;
        if (this.isConnected) {
          if (!this.uploadCancelled) {
            if (this.uploadingData[index].formData.content_type == 'document') {
              this.uploadingData[index].status = 'failed';
              this.modalService.open(PublicationNotUploadedComponent, { centered: true });
            }
            if (this.uploadingData[index].formData.content_type == 'video') {
              this.uploadingData[index].status = 'failed';
              this.modalService.open(VideoNotUploadedComponent, { centered: true });
            }
            if (this.uploadingData[index].formData.content_type == 'audio') {
              this.uploadingData[index].status = 'failed';
              this.modalService.open(AudioNotUploadedComponent, { centered: true });
            }
          }
        }

      });
  }

  async uploadFilesToAWS(image, path, uploadType, index) {

    // const containerName = environment.containerName;
    // const pipeline = newPipeline(new AnonymousCredential(), {
    //   retryOptions: { maxTries: 4 }, // Retry options
    //   userAgentOptions: { userAgentPrefix: "AdvancedSample V1.0.0" }, // Customized telemetry string
    //   keepAliveOptions: {
    //     // Keep alive is enabled by default, disable keep alive by setting false
    //     enable: false
    //   }
    // });
    // var blobUri = 'https://' + 'STORAGE_ACCOUNT' + '.blob.core.windows.net';
    // console.log(saas,'saas');
    // console.log(path,'path');
    // var blobService = AzureStorage.Blob.createBlobServiceWithSas(saas[0], saas[1]).withFilter(this.cancelUploadFilter);
    // var customBlockSize = {partSize: 10 * 1024 * 1024}
    // blobService.singleBlobPutThresholdInBytes = customBlockSize;
    let saas = path.url.split('?');

    AWS.config.update({
      region: environment.aws.region,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId:  environment.aws.IdentityPoolId,
      }),
    });

    var s3 = new AWS.S3({
      apiversion: '2006-03-01',
      params: { Bucket: environment.aws.aws_bucket_name },
    })

    // var s3 = new AWS.S3(environment.s3Config);
    var options = {partSize: 1024 * 1024 * 5};
    var speedSummary = s3.upload({Bucket: environment.aws.aws_bucket_name, ACL:'public-read', Key: path.path, Body: image, options},
      // var speedSummary = blobService.createBlockBlobFromBrowserFile(environment.containerName, path.path, image, { blockSize: customBlockSize },
      (error, result, response) => {
        if (error) {

          this.uploadingData[index].status = 'failed';
          this.pendingCounter--;
          this.index++;
          this.isUploading = false;
          localStorage.setItem('uploadingProcess', 'false');

          if (this.isConnected) {
            if (this.uploadingData[index].formData.content_type == 'document') {
              this.modalService.open(PublicationNotUploadedComponent, { centered: true });
            }
            if (this.uploadingData[index].formData.content_type == 'video') {
              this.modalService.open(VideoNotUploadedComponent, { centered: true });
            }
            if (this.uploadingData[index].formData.content_type == 'audio') {
              this.modalService.open(AudioNotUploadedComponent, { centered: true });
            }
          }
        } else {
          if (uploadType == 'content') {
            this.uploadStarted = true
            this.uploadingData[index].uploadedBytes += this.uploadingData[index].content.size;
            this.uploadingData[index].isSubmitted = true;
            // this.uploadingData[index].status = 'done';

            // if (this.pendingCounter > 1)
            //   this.pendingCounter--;
            // console.log(result);

            this.onSubmit();

            //if (this.uploadingData.length == (index + 1))
          }
          else if (uploadType == 'audioBook') {
            this.uploadStarted = true
            this.uploadingData[index].uploadedBytes += this.uploadingData[index].audioBook.size;
            if (this.uploadingData[index].formData.library_type != 'wipod' || this.uploadingData[index].trailer) {
              let obj = {
                type: 'trailer',
                name: this.uploadingData[index].trailer.name,
                index: index
              }
              this._authService.ngSubscribe.next(obj);
            }
            else {
              this.onSubmit();
            }
            // await this.getPreAssignedURL('trailer', this.uploadingData[index].trailer.name, index);
          }
          else if (uploadType == 'trailer') {
            this.uploadStarted = true
            this.uploadingData[index].uploadedBytes += this.uploadingData[index].trailer.size;
            if (this.uploadingData[index].formData.library_type != 'wipod') {
              let obj = {
                type: 'content',
                name: this.uploadingData[index].content.name,
                index: index
              }
              this._authService.ngSubscribe.next(obj);
            }
            else {
              this.onSubmit();
            }
            // await this.getPreAssignedURL('content', this.uploadingData[index].content.name, index);
          }
        }
      });

    speedSummary.on('httpUploadProgress', () => {

      this.speedSummary = speedSummary;

      if (uploadType == 'content' || uploadType == 'audioBook' || uploadType == 'trailer') {
        // let total_item = 1;
        let fileSize = 0;
        fileSize = this.uploadingData[index].content ? this.uploadingData[index].content.size : 0;

        if (this.uploadingData[index].audioBook) {
          // total_item = total_item + 1;
          fileSize += this.uploadingData[index].audioBook.size;
        }
        if (this.uploadingData[index].trailer) {
          // total_item = total_item + 1;
          fileSize += this.uploadingData[index].trailer.size;
        }
        // this.uploadingData[index].formData['total_size'] = fileSize;
        this.uploadingData[index].httpUploadProgress = +(((+speedSummary.totalBytes + this.uploadingData[index].uploadedBytes) / fileSize) * 100).toFixed(0);
        if (this.uploadingData[index].httpUploadProgress >= 99) {
          this.disableCancel = true;
        }
        // this.uploadingData[index].httpUploadProgress = +(((+speedSummary.completeSize + this.uploadingData[index].uploadedBytes) / fileSize) * 100).toFixed(0);
      }
    });
    return;
    /*
    const blobServiceClient = new BlobServiceClient(path.url, pipeline)
    const containerClient = blobServiceClient.getContainerClient(containerName)
    const client = containerClient.getBlockBlobClient(path.path)
    const response = await client.uploadBrowserData(image, {
      blockSize: 4 * 1024 * 1024, // 4MB block size
      concurrency: 8, // 20 concurrency
      onProgress: (ev: any) => {
        if (uploadType == 'content' || uploadType == 'audioBook' || uploadType == 'trailer') {
          // let total_item = 1;
          let fileSize = this.uploadingData[index].content.size;

          if (this.uploadingData[index].audioBook) {
            // total_item = total_item + 1;
            fileSize += this.uploadingData[index].audioBook.size;
          }
          if (this.uploadingData[index].trailer) {
            // total_item = total_item + 1;
            fileSize += this.uploadingData[index].trailer.size;
          }
          this.uploadingData[index].formData['total_size'] = fileSize;
          this.uploadingData[index].progress = +(((ev.loadedBytes + this.uploadingData[index].uploadedBytes) / fileSize) * 100).toFixed(0);
        }
      },
      blobHTTPHeaders: { blobContentType: image.type }
    })

    if (response._response.status == 201) {

      if (uploadType == 'content') {

        this.uploadingData[index].uploadedBytes += this.uploadingData[index].content.size;
        this.uploadingData[index].isSubmitted = true;
        this.uploadingData[index].status = 'done';

        // if (this.pendingCounter > 1)
        //   this.pendingCounter--;

        this.index++;
        this.onSubmit();

        if (this.uploadingData[this.index]) {
          let obj = {};
          if (this.uploadingData[this.index].audioBook) {
            obj = {
              type: 'audioBook',
              name: this.uploadingData[this.index].audioBook.name,
              index: this.index
            }
          }
          else if (this.uploadingData[this.index].trailer) {
            obj = {
              type: 'trailer',
              name: this.uploadingData[this.index].trailer.name,
              index: this.index
            }
          }
          else if (this.uploadingData[this.index].content) {
            obj = {
              type: 'content',
              name: this.uploadingData[this.index].content.name,
              index: this.index
            }
          }

          this._authService.ngSubscribe.next(obj);
        }

        //if (this.uploadingData.length == (index + 1))
      }
      else if (uploadType == 'audioBook') {
        this.uploadingData[index].uploadedBytes += this.uploadingData[index].audioBook.size;
        let obj = {
          type: 'trailer',
          name: this.uploadingData[index].trailer.name,
          index: index
        }
        this._authService.ngSubscribe.next(obj);
        // await this.getPreAssignedURL('trailer', this.uploadingData[index].trailer.name, index);
      }
      else if (uploadType == 'trailer') {
        this.uploadingData[index].uploadedBytes += this.uploadingData[index].trailer.size;
        let obj = {
          type: 'content',
          name: this.uploadingData[index].content.name,
          index: index
        }
        this._authService.ngSubscribe.next(obj);
        // await this.getPreAssignedURL('content', this.uploadingData[index].content.name, index);
      }
    }
    else {
      // this.showProgress = false;
      if (this.uploadingData[index].formData.content_type == 'document') {
        this.modalService.open(PublicationNotUploadedComponent, { centered: true });
      }
      if (this.uploadingData[index].formData.content_type == 'video') {
        this.modalService.open(VideoNotUploadedComponent, { centered: true });
      }
      if (this.uploadingData[index].formData.content_type == 'audio') {
        this.modalService.open(AudioNotUploadedComponent, { centered: true });
      }
      // this._spinner.hide();
      // this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      // this.isError = true;
    }
    */
  }

  onSubmit() {
    this.submitted = true;
    this.speedSummary = null;
    let data = [];
    for (let index = 0; index < this.uploadingData.length; index++) {

      if (this.uploadingData[index].isNew && this.uploadingData[index].isSubmitted) {

        const taggedInterestsAttributes = [];

        this.uploadingData[index].formData.tagged_interests_attributes.forEach(element => {
          taggedInterestsAttributes.push({
            interest_id: element.id
          })
        });
        let fileSize = 0;
        fileSize = this.uploadingData[index].content ? this.uploadingData[index].content.size : 0;

        if (this.uploadingData[index].audioBook) {
          // total_item = total_item + 1;
          fileSize += this.uploadingData[index].audioBook.size;
        }
        if (this.uploadingData[index].trailer) {
          // total_item = total_item + 1;
          fileSize += this.uploadingData[index].trailer.size;
        }
        // this.uploadingData[index].formData['total_size'] = fileSize;

        this.uploadingData[index].formData['total_size'] = fileSize;
        let totalSize = this.uploadingData[index].formData.total_size;
        const number = this.uploadingData[index].formData.duration_number;
        const number_bulk = this.uploadingData[index].formData.duration_number_bulk;
        const units = this.uploadingData[index].formData.duration_units;
        const units_bulk = this.uploadingData[index].formData.duration_units_bulk;

        const obj = {
          out_line: this.uploadingData[index].formData.out_line,
          description: this.uploadingData[index].formData.description,
          library_type: this.uploadingData[index].formData.library_type,
          is_deleted: false,
          link: this.uploadingData[index].formData.link,
          content_type: this.uploadingData[index].formData.content_type,
          tagged_interests_attributes: taggedInterestsAttributes,
          material_id: this.uploadingData[index].formData.material_id[0]['id'],
          duration_number: this.uploadingData[index].formData.duration_number,
          duration_units: this.uploadingData[index].formData.duration_units,
          duration_number_bulk: this.uploadingData[index].formData.duration_number_bulk,
          duration_units_bulk: this.uploadingData[index].formData.duration_units_bulk,
          file_size: parseInt((totalSize / 1024).toFixed(0)),
          is_downloadable: this.uploadingData[index].formData.is_downloadable,
          thumbnail: this.uploadingData[index].formData.thumbnail,
          adult_content: this.uploadingData[index].formData.adult_content == 'all' ? false : true,
          tokens: this.uploadingData[index].formData.tokens || 0,
          duration: number + ' ' + units,
          duration_bulk: number_bulk + ' ' + units_bulk
        }

        if (this.uploadingData[index].formData.no_of_clicks >= 0) {
          obj['no_of_clicks'] = this.uploadingData[index].formData.no_of_clicks;
        }

        if (this.uploadingData[index].formData.audio_book) {
          obj['audio_book'] = this.uploadingData[index].formData.audio_book;
        }
        if (this.uploadingData[index].formData.preview_link) {
          obj['preview_link'] = this.uploadingData[index].formData.preview_link;
        }
        if (this.uploadingData[index].formData.content_prices_attributes) {
          obj['content_prices_attributes'] = this.uploadingData[index].formData.content_prices_attributes;
        }
        obj['max_value_for_price_range'] = this.uploadingData[index].formData.max_value_for_price_range;
        obj['price_range_limit'] = this.uploadingData[index].formData.price_range_limit;

        if (this.uploadingData[index].formData.library_type == 'wipod') {
          obj['library_type'] = this.uploadingData[index].formData.library_type;
          obj['template_id'] = this.uploadingData[index].formData.template_id;
          obj['publication_text'] = this.uploadingData[index].formData.publication_text;
          delete obj.link;
        }

        data.push(obj);
        this.uploadingData[this.index].isSubmitted = false;
      }
    }
    let uploadSubscriber;

    if (data[0].library_type == 'wipod') {
      uploadSubscriber = this._contentsService.createWIPODcontent(data);
    }
    else {
      uploadSubscriber = this._contentsService.createContent(data);
    }
    // this.showProgress = true;

    uploadSubscriber.subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          //
          break;
        case HttpEventType.ResponseHeader:
          //
          break;
        case HttpEventType.UploadProgress:
          // this.progress = Math.round(event.loaded / event.total * 100);
          //
          break;
        case HttpEventType.Response:
          let response = event.body;

          this.index++;
          if (this.uploadingData[this.index]) {
            let obj = {};
            if (this.uploadingData[this.index].audioBook) {
              obj = {
                type: 'audioBook',
                name: this.uploadingData[this.index].audioBook.name,
                index: this.index
              }
            }
            else if (this.uploadingData[this.index].trailer) {
              obj = {
                type: 'trailer',
                name: this.uploadingData[this.index].trailer.name,
                index: this.index
              }
            }
            else if (this.uploadingData[this.index].content) {
              obj = {
                type: 'content',
                name: this.uploadingData[this.index].content.name,
                index: this.index
              }
            }
            this._authService.ngSubscribe.next(obj);
          }

          if (response.success) {
            this.uploadStarted = false;
            this.uploadingData[this.index - 1].httpUploadProgress = 100;
            // this.uploadingData[this.index - 1].progress = 100;
            this.uploadingData[this.index - 1].status = 'done';
            this.disableCancel = false;

            if (this.pendingCounter > 1) {
              this.pendingCounter--;
            }
            else if (this.pendingCounter == 1) {
              this.pendingCounter--;
              this.isUploading = false;
              localStorage.setItem('uploadingProcess', 'false');
            }
            return;
          }
          else {
            this.uploadingData[this.index - 1].status = 'failed';
            let subscriptionFlag = false;
            this.disableCancel = false;
            this.pendingCounter--;
            this.isUploading = false;
            localStorage.setItem('uploadingProcess', 'false');
            if (response.status === 426) {
              const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
              modalRef.componentInstance.spaceError = this.str;
              modalRef.componentInstance.contentType = this.uploadingData[this.index - 1].formData.content_type;
              return;
            }
            else if (response.errors && response.errors instanceof Array && response.errors.length > 0) {
              response.errors.forEach(element => {
                if (element.detail == "You need to upgrade your subscription plan") {
                  subscriptionFlag = true;
                }
              });
            }

            if (subscriptionFlag) {
              const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
              modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CHOOSE_THE_SUBSCRIPTION_PLAN;
            }
            else {
              // this.isError = true;
              if (this.uploadingData[0].formData.content_type == 'Publications') {
                const modalRef = this.modalService.open(PublicationNotUploadedComponent, { centered: true });
                if (response.errors && response.errors[0]) {
                  modalRef.componentInstance.message = response.errors[0].detail;
                }
                return;
              }
              if (this.uploadingData[0].formData.content_type == 'Videos') {
                const modalRef = this.modalService.open(VideoNotUploadedComponent, { centered: true });
                if (response.errors && response.errors[0]) {
                  modalRef.componentInstance.message = response.errors[0].detail;
                }
                return;
              }
              if (this.uploadingData[0].formData.content_type == 'Audios') {
                const modalRef = this.modalService.open(AudioNotUploadedComponent, { centered: true });
                if (response.errors && response.errors[0]) {
                  modalRef.componentInstance.message = response.errors[0].detail;
                }
                return;
              }
            }
          }
          break;
      }
    });
    return;
  }

  hideUploadPanel() {
    let uploadPanel = document.getElementsByClassName("upload-panel");
    uploadPanel[0].classList.add('hide');
    uploadPanel[0].classList.remove('show');
    console.log(this.uploadStarted, "I am the result");
    if (this.uploadStarted) {
      this.pendingCounter--;
      this.uploadCancelled = true;
      this.isUploading = false;
      localStorage.setItem('uploadingProcess', 'false');
    }
    this.uploadingData = [];
    this.index = 0;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.seqFileSubscription.unsubscribe();
    this.uploadDataSubscription.unsubscribe();
  }
  showUploadPanel() {
    let uploadPanel = document.getElementsByClassName("upload-panel");
    uploadPanel[0].classList.remove('hide');
    uploadPanel[0].classList.add('show');
  }
}
